export default __webpack_public_path__ + "static/media/goals-empty-state.16f50185.svg";